import {
  call, put, select, takeLatest,
} from 'redux-saga/effects';
import convertObjToQueryStr from '../../../helpers/convertObjToQueryStr';

import { getSpecialServicesRequest, getSpecialServicesResponse } from '../../slices/trip';
import axios from '../axiosConfig';

const queryString = require('query-string');

function* getSpecialServicesWorker(action) {
  try {
    const {
      city,
    } = yield select((store) => store.tripSearch.searchObj.cruise.filters);
    let request = {
      ...action.payload,
      passengerCityCode: city ? city.value : null,
    };

    // format staterooms object to query-string
    request = {
      ...request,
      ...convertObjToQueryStr(request.searchInputs, 'staterooms'),
    };
    delete request.searchInputs;

    const config = {
      method: 'get',
      url: `cruises/getSpecialServices?${queryString.stringify(request)}`,
    };
    const response = yield call(axios, config);
    if (response.data && response.data.length) {
      yield put(getSpecialServicesResponse({
        specialServices: response.data,
        tripId: action.payload.tripId,
      }));
    } else throw new Error();
  } catch (error) {
    let errorMsg = 'Could not find special services';
    if (error && error.response) {
      errorMsg = `${error.response.data.title || ''} ${error.response.data.detail || ''}`.trim();
    }
    yield put(getSpecialServicesResponse({ error: errorMsg }));
  }
}

function* getSpecialServicesWatcher() {
  yield takeLatest(getSpecialServicesRequest.toString(), getSpecialServicesWorker);
}

export default getSpecialServicesWatcher;
